import { AddOrganizationUser, editOrganizationUser } from "../../../../Api/Network";
import { Globals } from "../../../../Global";

export const handleAddUser = async ({ name, phone, bio, urlWebHook, tokenWebHook, ip }) => {
    const data = await AddOrganizationUser(
        Globals.token,
        name,
        phone,
        bio,
        urlWebHook,
        tokenWebHook,
        ip
    );
    return data;
};

export const handleEditUser = async ({ id, name, phone, bio, urlWebHook, tokenWebHook, ip }) => {
    const data = await editOrganizationUser(
        Globals.token,
        id,
        name,
        phone,
        bio,
        urlWebHook,
        tokenWebHook,
        ip
    );
    return data;
};
